import axios from "axios";
import { config } from "../config";
import AuthHelper from "./AuthHelper";
import Constants from "./Constants";

const baseUrl = config.apiUrl;

const LoginHelper = {
  attemptLogin: (email, password) => {
    const url = `${baseUrl}log-in`;
    const body = {
      user: {
        email,
        password
      }
    };

    return new Promise((resolve, reject) => {
      axios
        .post(url, body)
        .then((res) => {
          const { jwt } = res.data;
          AuthHelper.setUserToken(jwt);
          resolve();
        })
        .catch((err) => {
          reject(Constants.Login.LOGIN_FAILED);
        });
    });
  }
};

export default LoginHelper;
